import React, { useEffect } from 'react'
import { Row } from 'react-bootstrap'
import DetalleAlmacenajeEspecialView from '../../components/listados/DetalleAlmacenajeEspecialView'
import { obtenerDetalleAlmacenajeEspecial } from '../../actions/listados'
import { connect } from 'react-redux'
import { COLORES } from '../../../../config/colores'

function DetalleAlmacenajeEspecial (props) {
  const { fechaD, fechaH, exportador, cereal, obtenerDetalleAlmacenajeEspecial, total, razonSocial } = props

  useEffect(() => {
    obtenerDetalleAlmacenajeEspecial(fechaD, fechaH, exportador, cereal, total)
  }, [obtenerDetalleAlmacenajeEspecial, fechaD, fechaH, exportador, cereal, total])

  return (
    <>
      <Row
        style={{
          margin: '0 2%',
          padding: '12px',
          backgroundColor: COLORES.grey.dark,
          color: 'white',
          justifyContent: 'space-between',
          borderRadius: '8px'
        }}
      >
        <h6>Exportador: <b>{razonSocial}</b></h6>
        <h6>Cereal: <b>{cereal}</b></h6>
        <h6>Stock: <b>{total.toLocaleString('es-ES')} kg.</b></h6>
      </Row>
      <DetalleAlmacenajeEspecialView />
    </>
  )
}

const mapActionsToProps = {
  obtenerDetalleAlmacenajeEspecial
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(DetalleAlmacenajeEspecial)
